"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var GameMode_1 = __importDefault(require("../Types/GameMode"));
var PlayTutorialMoves_1 = require("./PlayTutorialMoves");
function useTutorial() {
    var gameMode = (0, react_redux_1.useSelector)(function (state) { return ({ gameMode: state.gameMode }); }).gameMode;
    var dispatch = (0, react_redux_1.useDispatch)();
    if (gameMode !== GameMode_1.default.TUTORIAL)
        return;
    var playTutorialMoves = function (quantity) {
        if (quantity === void 0) { quantity = 1; }
        return dispatch((0, PlayTutorialMoves_1.playTutorialMovesAction)(quantity));
    };
    return {
        playNextMoves: playTutorialMoves,
        playNextMove: function () { return playTutorialMoves(); },
        setOpponentsPlayAutomatically: function (value) {
            if (value === void 0) { value = true; }
            return value ? playTutorialMoves(Infinity) : playTutorialMoves(0);
        }
    };
}
exports.default = useTutorial;
//# sourceMappingURL=useTutorial.js.map